import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  Grid,
  Card,
  CardMedia,
} from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  item: {
    title: string;
    description: string;
    image: any; // Store full object for easy access to url and altText
    order: number;
  };
  handleItemChange: (field: string, value: any) => void;
  images: any[];
  addItem: () => void;
};

const AddItemModal: React.FC<Props> = ({
  open,
  onClose,
  item,
  handleItemChange,
  images,
  addItem,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" marginBottom={2}>
          {t("add_new_image")}
        </Typography>

        <Grid container spacing={2}>
          {/* Title */}
          <Grid item xs={12}>
            <TextField
              label={t("Title")}
              fullWidth
              value={item.title}
              onChange={(e) => handleItemChange("title", e.target.value)}
            />
          </Grid>

          {/* Description */}
          <Grid item xs={12}>
            <TextField
              label={t("Description")}
              fullWidth
              value={item.description}
              onChange={(e) => handleItemChange("description", e.target.value)}
            />
          </Grid>

          {/* Order */}
          <Grid item xs={12}>
            <TextField
              label={t("Order")}
              type="number"
              fullWidth
              value={item.order}
              onChange={(e) =>
                handleItemChange("order", Number(e.target.value))
              }
            />
          </Grid>

          {/* Select Image */}
          <Grid item xs={12}>
            <Select
              label={t("Image")}
              value={item.image}
              displayEmpty
              onChange={(e) => handleItemChange("image", e.target.value)}
              fullWidth
            >
              {images.map((img) => (
                <MenuItem key={img._id} value={img}>
                  {img.altText}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          {/* ✅ Display Selected Image */}
          {item.image && (
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Card>
                <CardMedia
                  component="img"
                  height="140"
                  image={item.image.url}
                  alt={item.image.altText}
                  sx={{
                    objectFit: "cover",
                    borderRadius: 1,
                  }}
                />
                <Typography variant="body2" sx={{ mt: 1, textAlign: "center" }}>
                  {item.image.altText}
                </Typography>
              </Card>
            </Grid>
          )}
        </Grid>

        {/* ✅ Add Button */}
        <Button
          onClick={addItem}
          sx={{ mt: 2 }}
          variant="contained"
          color="primary"
          fullWidth
        >
          {t("add")}
        </Button>
      </Box>
    </Modal>
  );
};

export default AddItemModal;
